"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3211],{

/***/ 96143:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({
    bulletsDirection: "row",
    bulletTextSize: "0.875rem",
    bullets: [
        {
            bulletText: "Support ticket management"
        },
        {
            bulletText: "Creative requests"
        }
    ]
});


/***/ }),

/***/ 7484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var segments_desktop_core_components_title_default_props__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51261);
/* harmony import */ var segments_desktop_core_components_paragraph_default_props__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14066);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


/* harmony default export */ __webpack_exports__["Z"] = (_object_spread_props(_object_spread({
    topic: {
        text: "Lorem ipsum dolor",
        color: "brand-blue"
    }
}, segments_desktop_core_components_title_default_props__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, segments_desktop_core_components_paragraph_default_props__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z), {
    textAlign: "left",
    mobileTextAlign: null // has to be null so it will default to regular text align
}));


/***/ }),

/***/ 13211:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "xe": function() { return /* binding */ PARAGRAPH_HORIZONTAL_PADDING_STRING; },
  "ZP": function() { return /* binding */ full_paragraph; }
});

// UNUSED EXPORTS: PARAGRAPH_HORIZONTAL_PADDING

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/button.js + 19 modules
var button_button = __webpack_require__(9709);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./utils/react.js
var utils_react = __webpack_require__(12783);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./segments/desktop/core-components/bullets/bullet-checked-icon.js


var BulletCheckedIcon = function(param) {
    var color = param.color, checkColor = param.checkColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "10",
                cy: "10",
                r: "10",
                fill: colors/* default */.Z[color] || "#CAF4E2",
                className: "circle"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "mark",
                d: "M6.27162 9.83382C5.98072 9.54874 5.50908 9.54874 5.21818 9.83382C4.92727 10.1189 4.92727 10.5811 5.21818 10.8662L8.19777 13.7862C8.48867 14.0713 8.96031 14.0713 9.25121 13.7862L15.2104 7.9462C15.5013 7.66112 15.5013 7.19891 15.2104 6.91382C14.9195 6.62874 14.4479 6.62874 14.1569 6.91382L8.72449 12.2376L6.27162 9.83382Z",
                fill: colors/* default */.Z[checkColor] || "#037F4C"
            })
        ]
    });
};
/* harmony default export */ var bullet_checked_icon = (BulletCheckedIcon);

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/core-components/bullets/bullets.scss.js


var BULLET_SIZE = 16;
var BULLET_SIZE_STRING = "".concat(BULLET_SIZE, "px");
var StyledBullets = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e3pqfjj0"
})("display:flex;flex-wrap:wrap;&.column{flex-direction:column;}.bullet-anchor-wrapper{text-decoration:none;color:unset;cursor:pointer;}.bullet{display:flex;align-items:flex-start;.bullet-icon{height:", BULLET_SIZE_STRING, ";width:", BULLET_SIZE_STRING, ";padding-top:8px;svg{height:", BULLET_SIZE_STRING, ";width:", BULLET_SIZE_STRING, ";}}.bullet-text{margin-left:8px;line-height:31px;padding-right:24px;}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){.bullet{width:100%;}}");

// EXTERNAL MODULE: ./segments/desktop/core-components/bullets/default-props.js
var default_props = __webpack_require__(96143);
;// CONCATENATED MODULE: ./segments/desktop/core-components/bullets/bullets.js






var Bullets = function(props) {
    var bullets = props.bullets, alternativeIcon = props.alternativeIcon, bulletsDirection = props.bulletsDirection, bulletTextSize = props.bulletTextSize, bulletsColor = props.bulletsColor, checkColor = props.checkColor;
    var renderBullet = function(bullet, bulletIndex) {
        var href = bullet.href, openInNewTab = bullet.openInNewTab;
        var anchorWrapper = function(children) {
            var target = openInNewTab ? "_blank" : undefined;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: "bullet-anchor-wrapper",
                href: href,
                target: target,
                children: children
            });
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(utils_react/* ConditionalWrapper */.M, {
            condition: href,
            wrapper: anchorWrapper,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bullet",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bullet-icon",
                        children: alternativeIcon || /*#__PURE__*/ (0,jsx_runtime.jsx)(bullet_checked_icon, {
                            color: bulletsColor,
                            checkColor: checkColor
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bullet-text",
                        style: {
                            fontSize: bulletTextSize
                        },
                        children: bullet.bulletText
                    })
                ]
            }, bulletIndex)
        });
    };
    if (!bullets) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBullets, {
        className: classnames_default()("bullets", bulletsDirection),
        children: bullets.map(function(bullet, bulletIndex) {
            return renderBullet(bullet, bulletIndex);
        })
    });
};
Bullets.defaultProps = default_props/* default */.Z;
/* harmony default export */ var bullets = (Bullets);

// EXTERNAL MODULE: ./contexts/segment-context.js
var segment_context = __webpack_require__(39944);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/title.js + 1 modules
var title_title = __webpack_require__(91265);
// EXTERNAL MODULE: ./segments/desktop/core-components/paragraph/paragraph.js + 1 modules
var paragraph = __webpack_require__(75073);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./client/services/cluster-config-service/cluster-config-service.js
var cluster_config_service = __webpack_require__(79092);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./client/components/system/monday-markup-language/monday-markup-language-component.js + 11 modules
var monday_markup_language_component = __webpack_require__(36239);
;// CONCATENATED MODULE: ./segments/desktop/core-components/icons/icons.scss.js


var StyledIcons = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1tcrf5n0"
})("display:flex;.icon-wrapper{display:flex;gap:8px;width:100%;img{max-height:32px;}.icon-texts-wrapper{display:flex;flex-direction:column;gap:8px;.title{.monday-markup-language-component{font-size:1.463rem;line-height:26px;font-weight:500;}}.subtitle{.monday-markup-language-component{font-size:1rem;line-height:20px;}}}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){display:flex;.icon-wrapper{flex-direction:column;align-items:center;padding-bottom:35px;.icon-texts-wrapper{align-items:center;text-align:center;.title{.monday-markup-language-component{font-size:1.125rem;}}.subtitle{.monday-markup-language-component{font-size:0.8125rem;}}}}}");

// EXTERNAL MODULE: ./segments/desktop/core-components/icons/default-props.js
var icons_default_props = __webpack_require__(80564);
;// CONCATENATED MODULE: ./segments/desktop/core-components/icons/icons.js
function icons_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            icons_define_property(target, key, source[key]);
        });
    }
    return target;
}





var Icons = function(props) {
    var icons = props.icons;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIcons, {
        className: "icons",
        children: icons.map(function(icon, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "icon-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, _object_spread({}, icon.image)),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "icon-texts-wrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "title",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(monday_markup_language_component/* default */.Z, {
                                    text: icon.title
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "subtitle",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(monday_markup_language_component/* default */.Z, {
                                    text: icon.subtitle
                                })
                            })
                        ]
                    })
                ]
            }, index);
        })
    });
};
/* harmony default export */ var icons = (Icons);
Icons.defaultProps = icons_default_props/* default */.Z;

// EXTERNAL MODULE: ./components/core/picture-with-link/picture-with-link-component.js
var picture_with_link_component = __webpack_require__(94640);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/default-props.js
var full_paragraph_default_props = __webpack_require__(7484);
;// CONCATENATED MODULE: ./segments/desktop/core-components/full-paragraph/full-paragraph.scss.js


var StyledFullParagraph = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eo3on790"
})("word-break:break-word;width:100%;display:flex;flex-direction:column;&.align-items-left{align-items:flex-start;}&.align-items-center{align-items:center;.title-wrapper{width:100%;}}&.align-items-right{align-items:flex-end;}&.with-left-line{border-width:2px;border-style:solid;padding-left:32px;}.full-paragraph-topic-image-and-text-wrapper{display:flex;flex-direction:column;}.full-paragraph-topic-image-wrapper{margin-bottom:40px;}.full-paragraph-topic{font-size:0.875rem;margin-bottom:16px;}.title-wrapper{margin-top:16px;margin-bottom:16px;}.paragraph-body-wrapper{}.icons-wrapper{margin-top:40px;margin-bottom:64px;}.bullets-wrapper{margin-top:32px;display:flex;@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){&.no-mobile-margin{margin-top:0;}}&.left{justify-content:flex-start;.bullets{justify-content:flex-start;}}&.center{justify-content:center;.bullets{justify-content:center;}}&.right{justify-content:flex-end;.bullets{justify-content:flex-end;}}}.full-paragraph-topic-image-wrapper{&.left{:global(.picture-component){justify-content:left;}}&.center{:global(.picture-component){justify-content:center;}}&.right{:global(.picture-component){justify-content:right;}}}.button-wrapper{margin-top:32px;display:flex;width:", function(param) {
    var buttonWidth = param.buttonWidth;
    return buttonWidth || "";
}, ";.button{width:", function(param) {
    var buttonWidth = param.buttonWidth;
    return buttonWidth || "";
}, ";}&.left{justify-content:flex-start;}&.center{justify-content:center;}&.right{justify-content:flex-end;}}");

// EXTERNAL MODULE: ./components/core/asset/asset-component.js + 2 modules
var asset_component = __webpack_require__(24961);
;// CONCATENATED MODULE: ./segments/desktop/core-components/full-paragraph/full-paragraph.js







function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function full_paragraph_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



















var PARAGRAPH_HORIZONTAL_PADDING = 32;
var PARAGRAPH_HORIZONTAL_PADDING_STRING = "".concat(PARAGRAPH_HORIZONTAL_PADDING, "px");
var FullParagraph = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(FullParagraph, PureComponent);
    var _super = (0,_create_super/* default */.Z)(FullParagraph);
    function FullParagraph() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, FullParagraph);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "getTextAlignBasedOnDeviceType", function() {
            var _props = _this.props, isMobileBrowser = _props.isMobileBrowser, textAlign = _props.textAlign, mobileTextAlign = _props.mobileTextAlign;
            if (!isMobileBrowser) return textAlign;
            return mobileTextAlign || textAlign;
        });
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "getTitleStyle", function() {
            var _props = _this.props, titleMinWidth = _props.titleMinWidth, titleWidth = _props.titleWidth, topicText = _props.topicText, spaceFromParagraph = _props.spaceFromParagraph;
            var style = {
                maxWidth: "min(".concat(titleWidth, ", ").concat(vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_MAX_WIDTH */.po, ")")
            };
            if (!topicText) {
                style = _object_spread_props(full_paragraph_object_spread({}, style), {
                    marginTop: 0
                });
            }
            if (spaceFromParagraph) {
                style = _object_spread_props(full_paragraph_object_spread({}, style), {
                    marginBottom: spaceFromParagraph
                });
            }
            if (_this.getTextAlignBasedOnDeviceType() === "center") {
                var minWidth = "min(".concat(titleMinWidth, ", ").concat(vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_MAX_WIDTH */.po, ", calc(100vw - ").concat(PARAGRAPH_HORIZONTAL_PADDING_STRING, "))");
                style = _object_spread_props(full_paragraph_object_spread({}, style), {
                    minWidth: minWidth
                });
            }
            return style;
        });
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "getButtonWrapperStyle", function() {
            var buttonTopMargin = _this.props.buttonTopMargin;
            if (!buttonTopMargin) return null;
            return {
                marginTop: buttonTopMargin
            };
        });
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "renderTopicImage", function(removeMargin) {
            var _props = _this.props, topic = _props.topic, topicBottomMargin = _props.topicBottomMargin;
            var image = topic.image;
            if ((image === null || image === void 0 ? void 0 : image.src) || (image === null || image === void 0 ? void 0 : image.href)) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("full-paragraph-topic-image-wrapper", _this.getTextAlignBasedOnDeviceType()),
                    style: {
                        marginBottom: !removeMargin && topicBottomMargin
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_with_link_component/* default */.Z, _object_spread_props(full_paragraph_object_spread({}, image), {
                        pictureComponentHeight: image === null || image === void 0 ? void 0 : image.height
                    }))
                });
            }
            return null;
        });
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "renderTopicText", function(removeMargin) {
            var _props = _this.props, topic = _props.topic, topicBottomMargin = _props.topicBottomMargin;
            var topicText = topic.text, color = topic.color, borderColor = topic.borderColor;
            if (topicText) {
                var borderStyles = borderColor && {
                    border: "1px solid ".concat(colors/* default */.Z[borderColor]),
                    borderRadius: "8px",
                    padding: "6px 12px"
                };
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "full-paragraph-topic",
                    style: full_paragraph_object_spread({
                        color: colors/* default */.Z[color],
                        marginBottom: !removeMargin && topicBottomMargin
                    }, borderStyles),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(monday_markup_language_component/* default */.Z, {
                        text: topicText
                    })
                });
            }
            return null;
        });
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "renderTopic", function() {
            var _props = _this.props, topic = _props.topic, topicBottomMargin = _props.topicBottomMargin;
            var allowTextAndImage = topic.allowTextAndImage, gap = topic.gap;
            if (allowTextAndImage) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "full-paragraph-topic-image-and-text-wrapper",
                    style: {
                        gap: gap,
                        marginBottom: topicBottomMargin
                    },
                    children: [
                        _this.renderTopicImage(true),
                        _this.renderTopicText(true)
                    ]
                });
            }
            return _this.renderTopicImage() || _this.renderTopicText();
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(FullParagraph, [
        {
            key: "getComponentInlineStyles",
            value: function getComponentInlineStyles() {
                var _props = this.props, textColor = _props.textColor, paragraphVerticalColoredLineColor = _props.paragraphVerticalColoredLineColor;
                var verticalLeftLineColor = colors/* default */.Z[paragraphVerticalColoredLineColor];
                var inlineStyles = {
                    textAlign: this.getTextAlignBasedOnDeviceType(),
                    color: textColor
                };
                if (paragraphVerticalColoredLineColor) {
                    inlineStyles = _object_spread_props(full_paragraph_object_spread({}, inlineStyles), {
                        borderImage: "linear-gradient(to bottom, ".concat(verticalLeftLineColor, ", transparent) 0 0 0 1")
                    });
                }
                return inlineStyles;
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, body = _props.body, bodyColor = _props.bodyColor, buttonConfig = _props.buttonConfig, bulletsConfig = _props.bulletsConfig, textSize = _props.textSize, titleSize = _props.titleSize, titleColor = _props.titleColor, isFirstSegment = _props.isFirstSegment, withDynamicParagraphTitle = _props.withDynamicParagraphTitle, withDynamicParagraphSubtitle = _props.withDynamicParagraphSubtitle, title = _props.title, titleClassName = _props.titleClassName, clusterConfig = _props.clusterConfig, activePagePath = _props.activePagePath, titleIcon = _props.titleIcon, iconsConfig = _props.iconsConfig, paragraphVerticalColoredLineColor = _props.paragraphVerticalColoredLineColor, textAlign = _props.textAlign, textWidth = _props.textWidth, removeBulletsMobileMarginTop = _props.removeBulletsMobileMarginTop, openLiveBoardExperience = _props.openLiveBoardExperience, renderButton = _props.renderButton, buttonWidth = _props.buttonWidth, assetUnderParagraph = _props.assetUnderParagraph;
                var _ref = assetUnderParagraph || {}, marginBetweenParagraphAndAsset = _ref.marginBetweenParagraphAndAsset, restAssetprops = _object_without_properties(_ref, [
                    "marginBetweenParagraphAndAsset"
                ]);
                var inlineComponentStyles = this.getComponentInlineStyles();
                var titleToUse = withDynamicParagraphTitle && (0,cluster_config_service/* getDynamicTitleConfigForPath */.Dp)(clusterConfig, activePagePath) || title;
                var subTitleToUse = withDynamicParagraphSubtitle && (0,cluster_config_service/* getDynamicSubTitleConfigForPath */.ER)(clusterConfig, activePagePath) || body;
                var alignItemsClassName = "align-items-".concat(textAlign);
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFullParagraph, {
                    className: classnames_default()("full-paragraph", (0,_define_property/* default */.Z)({
                        "with-left-line": paragraphVerticalColoredLineColor
                    }, alignItemsClassName, textAlign)),
                    style: inlineComponentStyles,
                    buttonWidth: buttonWidth,
                    children: [
                        this.renderTopic(),
                        titleToUse && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "title-wrapper",
                            style: this.getTitleStyle(),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(title_title/* default */.Z, {
                                title: titleToUse,
                                titleSize: titleSize,
                                titleColor: titleColor,
                                titleIcon: titleIcon,
                                isFirstSegment: isFirstSegment,
                                titleClassName: titleClassName
                            })
                        }),
                        subTitleToUse && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "paragraph-body-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(paragraph/* default */.Z, {
                                body: subTitleToUse,
                                bodyColor: bodyColor,
                                textSize: textSize,
                                isFirstSegment: isFirstSegment,
                                textWidth: textWidth
                            })
                        }),
                        bulletsConfig && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()("bullets-wrapper", this.getTextAlignBasedOnDeviceType(), {
                                "no-mobile-margin": removeBulletsMobileMarginTop
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bullets, full_paragraph_object_spread({}, bulletsConfig))
                        }),
                        iconsConfig && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()("icons-wrapper", this.getTextAlignBasedOnDeviceType()),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons, full_paragraph_object_spread({}, iconsConfig))
                        }),
                        buttonConfig && buttonConfig.buttonType && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()("button-wrapper", this.getTextAlignBasedOnDeviceType()),
                            style: this.getButtonWrapperStyle(),
                            children: renderButton && renderButton() || /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* default */.Z, full_paragraph_object_spread({}, buttonConfig, openLiveBoardExperience ? {
                                onClick: openLiveBoardExperience
                            } : {}))
                        }),
                        assetUnderParagraph && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "paragraph-asset-wrapper",
                            style: {
                                marginTop: marginBetweenParagraphAndAsset
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, full_paragraph_object_spread({}, restAssetprops))
                        })
                    ]
                });
            }
        }
    ]);
    return FullParagraph;
}(react.PureComponent);
FullParagraph.defaultProps = full_paragraph_default_props/* default */.Z;
/* harmony default export */ var full_paragraph = ((0,segment_context/* withSegmentsData */.c)((0,router.withRouter)((0,generic_config_context/* withGenericConfig */.P)(FullParagraph))));


/***/ }),

/***/ 80564:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({
    icons: [
        {
            image: {
                src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/customer-support/phone.png",
                alt: "Telephone icon"
            },
            title: "24/7",
            subtitle: "support anytime,<br>anywhere"
        },
        {
            image: {
                src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/customer-support/heart.png",
                alt: "Heart icon"
            },
            title: "Voted #1",
            subtitle: "Most Loved by<br>customers on G2"
        },
        {
            image: {
                src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/customer-support/fast.png",
                alt: "Fast clock icon"
            },
            title: "2 hour",
            subtitle: "average<br>response time"
        }
    ]
});


/***/ }),

/***/ 14066:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({
    body: "monday.com, ranked #1 for productivity, helps teams manage and execute projects that deliver results on time."
});


/***/ }),

/***/ 75073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Paragraph; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./utils/strings.js
var strings = __webpack_require__(11685);
// EXTERNAL MODULE: ./client/components/system/monday-markup-language/monday-markup-language-component.js + 11 modules
var monday_markup_language_component = __webpack_require__(36239);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/core-components/paragraph/paragraph.scss.js

var StyledParagraph = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ehzaxgp0"
})(".paragraph-body{font-size:1.125rem;line-height:32px;margin:0;//overide h3 global definition\n    word-break:break-word;&.xs{font-size:0.8125rem;line-height:20px;}&.sm{font-size:0.875rem;line-height:22px;}&.ms{font-size:1rem;line-height:24px;}&.md{font-size:1.125rem;line-height:32px;}&.lg{font-size:1.375rem;line-height:40px;}}");

// EXTERNAL MODULE: ./segments/desktop/core-components/paragraph/default-props.js
var default_props = __webpack_require__(14066);
;// CONCATENATED MODULE: ./segments/desktop/core-components/paragraph/paragraph.js






function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}








var Paragraph = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(Paragraph, PureComponent);
    var _super = (0,_create_super/* default */.Z)(Paragraph);
    function Paragraph() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, Paragraph);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "getStyle", function() {
            var _props = _this.props, bodyColor = _props.bodyColor, textWidth = _props.textWidth;
            var customStyle = {
                maxWidth: textWidth
            };
            if (bodyColor && colors/* default */.Z[bodyColor]) {
                customStyle = _object_spread_props(_object_spread({}, customStyle), {
                    color: colors/* default */.Z[bodyColor]
                });
            }
            return customStyle;
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(Paragraph, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, body = _props.body, textSize = _props.textSize, isFirstSegment = _props.isFirstSegment, className = _props.className;
                var CustomTag = isFirstSegment ? "h2" : "div";
                var style = this.getStyle();
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledParagraph, {
                    className: classnames_default()("paragraph-wrapper", className),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(monday_markup_language_component/* default */.Z, {
                        tagName: CustomTag,
                        className: classnames_default()("paragraph-body", textSize),
                        text: (0,strings.encloseBoldTag)(body),
                        style: style
                    })
                });
            }
        }
    ]);
    return Paragraph;
}(react.PureComponent);

Paragraph.defaultProps = default_props/* default */.Z;


/***/ }),

/***/ 49929:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DJ": function() { return /* binding */ titleLineHeights; },
/* harmony export */   "mo": function() { return /* binding */ titleFontSizes; },
/* harmony export */   "t_": function() { return /* binding */ titleFontSizeNumber; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);
/* harmony import */ var constants_sizes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77869);


var _obj;
var titleFontSizeNumber = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XXS */ .Mp, 0.6875), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XS_M */ .g4, 0.875), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XS_ML */ .l$, 1), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XS_L */ .L4, 1.125), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.XS, 1.375), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.SM, 1.75), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.MD, 2.25), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.LG, 2.75), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .LGR */ .Re, 3.375), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.XL, 4), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XXL */ .T3, 4.5), _obj);
var _obj1;
var titleLineHeights = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XXS */ .Mp, "32px"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XS_M */ .g4, "32px"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XS_ML */ .l$, "32px"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XS_L */ .L4, "32px"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.XS, "32px"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.SM, "40px"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.MD, "48px"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.LG, "60px"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .LGR */ .Re, "68px"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.XL, "72px"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XXL */ .T3, "85px"), _obj1);
var _obj2;
var titleFontSizes = (_obj2 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XXS */ .Mp, "".concat(titleFontSizeNumber[constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XXS */ .Mp], "rem")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XS_M */ .g4, "".concat(titleFontSizeNumber[constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XS_M */ .g4], "rem")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XS_ML */ .l$, "".concat(titleFontSizeNumber[constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XS_ML */ .l$], "rem")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XS_L */ .L4, "".concat(titleFontSizeNumber[constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XS_L */ .L4], "rem")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.XS, "".concat(titleFontSizeNumber[constants_sizes__WEBPACK_IMPORTED_MODULE_1__.XS], "rem")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.SM, "".concat(titleFontSizeNumber[constants_sizes__WEBPACK_IMPORTED_MODULE_1__.SM], "rem")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.MD, "".concat(titleFontSizeNumber[constants_sizes__WEBPACK_IMPORTED_MODULE_1__.MD], "rem")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.LG, "".concat(titleFontSizeNumber[constants_sizes__WEBPACK_IMPORTED_MODULE_1__.LG], "rem")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .LGR */ .Re, "".concat(titleFontSizeNumber[constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .LGR */ .Re], "rem")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.XL, "".concat(titleFontSizeNumber[constants_sizes__WEBPACK_IMPORTED_MODULE_1__.XL], "rem")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XXL */ .T3, "".concat(titleFontSizeNumber[constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XXL */ .T3], "rem") // 72px
), _obj2);


/***/ }),

/***/ 51261:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({
    title: "Lorem ipsum dolor sit amet, consectetur adipiscing elit."
});


/***/ }),

/***/ 91265:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ title; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./client/components/system/monday-markup-language/monday-markup-language-component.js + 11 modules
var monday_markup_language_component = __webpack_require__(36239);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./utils/strings.js
var strings = __webpack_require__(11685);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./utils/react.js
var react = __webpack_require__(12783);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/default-props.js
var default_props = __webpack_require__(51261);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/consts.js
var consts = __webpack_require__(49929);
;// CONCATENATED MODULE: ./segments/desktop/core-components/title/title.scss.js




var StyledTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e168hrcx0"
})(".core-title{font-size:2.25rem;font-weight:400;line-height:48px;word-break:break-word;&.xss{font-size:", consts/* titleFontSizes */.mo[sizes/* XXS */.Mp], ";line-height:32px;font-weight:400;}&.xs_m{font-size:", consts/* titleFontSizes */.mo[sizes/* XS_M */.g4], ";line-height:32px;font-weight:400;}&.xs_ml{font-size:", consts/* titleFontSizes */.mo[sizes/* XS_ML */.l$], ";line-height:32px;font-weight:400;}&.xs_l{font-size:", consts/* titleFontSizes */.mo[sizes/* XS_L */.L4], ";line-height:32px;font-weight:400;}&.xs{font-size:", consts/* titleFontSizes */.mo[sizes.XS], ";line-height:32px;font-weight:400;}&.sm{font-size:", consts/* titleFontSizes */.mo[sizes.SM], ";line-height:40px;font-weight:400;}&.md{font-size:", consts/* titleFontSizes */.mo[sizes.MD], ";line-height:48px;font-weight:400;}&.lg{font-size:", consts/* titleFontSizes */.mo[sizes.LG], ";line-height:60px;font-weight:700;}&.lgr{font-size:", consts/* titleFontSizes */.mo[sizes/* LGR */.Re], ";line-height:68px;font-weight:700;}&.xl{font-size:", consts/* titleFontSizes */.mo[sizes.XL], ";line-height:72px;font-weight:700;}&.xxl{font-size:", consts/* titleFontSizes */.mo[sizes/* XXL */.T3], ";line-height:85px;font-weight:700;}}.title-and-icon-wrapper{display:flex;.icon-wrapper{margin-right:14px;display:flex;align-items:center;.picture-icon-wrapper{display:flex;height:32px;.title-icon{height:100%;}}&.xss{.picture-icon-wrapper{height:8px;}}&.xs_m{.picture-icon-wrapper{height:12px;}}&.xs{.picture-icon-wrapper{height:18px;}}&.sm{.picture-icon-wrapper{height:24px;}}&.md{.picture-icon-wrapper{height:32px;}}&.lg{.picture-icon-wrapper{height:38px;}}&.lgr{.picture-icon-wrapper{height:44px;}}&.xl{.picture-icon-wrapper{height:56px;}}&.xxl{.picture-icon-wrapper{height:62px;}}&.lgr,&.xl,&.xxl{margin-right:20px;}}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH_M */.TI, "){.core-title-container .core-title{font-size:2.25rem;line-height:48px;font-weight:400;&.md,&.lg{font-size:1.75rem;line-height:40px;font-weight:700;}&.xl,&.lgr{font-size:2.25rem;line-height:48px;font-weight:700;}&.xxl{font-size:2.75rem;line-height:48px;font-weight:700;}}.title-and-icon-wrapper{.icon-wrapper{.picture-icon-wrapper{height:32px;}&.md,&.lg,&.xl{.picture-icon-wrapper{height:24px;}}}}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/title/title.js









var Title = function(props) {
    var title = props.title, titleSize = props.titleSize, titleColor = props.titleColor, isFirstSegment = props.isFirstSegment, titleIcon = props.titleIcon, titleClassName = props.titleClassName;
    var getTitleStyle = function() {
        if (!titleColor) {
            return null;
        }
        var titleStyle = {
            color: colors/* default */.Z[titleColor]
        };
        return titleStyle;
    };
    var renderIcon = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classnames_default()("icon-wrapper", titleSize),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                src: titleIcon,
                alt: "",
                className: "title-icon",
                pictureClass: "picture-icon-wrapper"
            })
        });
    };
    var titleAndIconWrapper = function(children) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: "title-and-icon-wrapper",
            children: children
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
        className: "core-title-container",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react/* ConditionalWrapper */.M, {
            condition: !!titleIcon,
            wrapper: titleAndIconWrapper,
            children: [
                titleIcon && renderIcon(),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(monday_markup_language_component/* default */.Z, {
                    tagName: isFirstSegment ? "h1" : "h2",
                    className: classnames_default()("core-title", titleSize, titleClassName),
                    text: (0,strings.encloseBoldTag)(title),
                    style: getTitleStyle()
                })
            ]
        })
    });
};
Title.defaultProps = default_props/* default */.Z;
/* harmony default export */ var title = (Title);


/***/ }),

/***/ 11685:
/***/ (function(module) {


var getCapitilizedString = function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
/**
 * returns the given string, surrounded by quotes
 * @param {*} str
 */ var addQuotesIfMissing = function(str) {
    if (!str) {
        return str;
    }
    if (!str.startsWith('"')) {
        str = '"' + str;
    }
    if (!str.endsWith('"')) {
        str += '"';
    }
    return str;
};
var toCamelCase = function(str) {
    if (!str) {
        return "";
    }
    var result = str // Lower cases the string
    .toLowerCase() // Replaces any - or _ characters with a space
    .replace(/[-_]+/g, " ") // Removes any non alphanumeric characters
    .replace(/[^\w\s]/g, "") // Uppercases the first character in each group immediately following a space
    // (delimited by spaces)
    .replace(/ (.)/g, function($1) {
        return $1.toUpperCase();
    });
    // upper case first letter
    return result.substring(0, 1).toUpperCase() + result.substring(1);
};
var toKebabCase = function(str) {
    var _str_match_map, _str_match;
    return str === null || str === void 0 ? void 0 : (_str_match = str.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)) === null || _str_match === void 0 ? void 0 : (_str_match_map = _str_match.map(function(x) {
        return x.toLowerCase();
    })) === null || _str_match_map === void 0 ? void 0 : _str_match_map.join("-");
};
// Returns the words count in the given text
var getWordsCount = function(text) {
    if (!text || !text.match) {
        return 0;
    }
    return text.match(/\S+/g).length;
};
// THIS IS TEMPORARY FIX FOR TEMPLATES GENERATOR
// Because historically a lot of pages contain bold tags
// With no closing tag in the end, causing the page to break
var encloseBoldTag = function(str) {
    if (!str || !str.match) {
        return str;
    }
    var openningBoldsCount = (str.replace(/ /g, "").match(/<b>/g) || []).length;
    var closingBoldsCount = (str.replace(/ /g, "").match(/<\/b>/g) || []).length;
    return openningBoldsCount > closingBoldsCount ? "".concat(str, "</b>") : str;
};
module.exports = {
    getCapitilizedString: getCapitilizedString,
    addQuotesIfMissing: addQuotesIfMissing,
    toCamelCase: toCamelCase,
    toKebabCase: toKebabCase,
    getWordsCount: getWordsCount,
    encloseBoldTag: encloseBoldTag
};


/***/ })

}]);